import { render, staticRenderFns } from "./DetalhesInventario.vue?vue&type=template&id=651f4f7a&scoped=true&"
import script from "./DetalhesInventario.vue?vue&type=script&lang=js&"
export * from "./DetalhesInventario.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesInventario.vue?vue&type=style&index=0&id=651f4f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f4f7a",
  null
  
)

export default component.exports